import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material'
import {
  STRIPE_SMART_HOME_BUNDLE_URL,
  STRIPE_SMART_HOME_URL,
} from '../../../../constants/stripeLinks'

export const Step3SmartHomeBranch = () => (
  <Stack spacing={2}>
    <Typography variant="h5">How many units do you want to protect?</Typography>
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box
          sx={{
            p: 3,
            borderRadius: 1.5,
            border: '1.5px solid',
            borderColor: 'primary.darker',
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            height: '100%',
          }}
        >
          <Typography variant="h5">Single Monitor</Typography>
          <Typography variant="body2" color="text.secondary">
            Protect one key location — kitchen or bath.
          </Typography>
          <Stack direction="row" alignItems="baseline" spacing={0.5}>
            <Typography variant="h3" fontWeight={700}>
              $350
            </Typography>
            <Typography variant="body2" color="text.secondary">
              one-time
            </Typography>
          </Stack>
          <Button
            variant="outlined"
            fullWidth
            onClick={() => window.open(STRIPE_SMART_HOME_URL, '_blank')}
            sx={{ borderColor: 'primary.darker', color: 'primary.darker', mt: 'auto' }}
          >
            Choose Single
          </Button>
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <Box
          sx={{
            p: 3,
            borderRadius: 1.5,
            bgcolor: 'primary.darker',
            color: 'common.white',
            display: 'flex',
            flexDirection: 'column',
            gap: 1.25,
            height: '100%',
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Typography variant="h5" sx={{ color: 'common.white' }}>
              4-Unit Bundle
            </Typography>
            <Chip
              label="Best Value"
              size="small"
              sx={{ bgcolor: 'common.white', color: 'primary.darker', fontWeight: 600 }}
            />
          </Stack>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.85)' }}>
            Cover kitchen, bath, laundry & main.
          </Typography>
          <Stack direction="row" alignItems="baseline" spacing={0.5}>
            <Typography variant="h3" fontWeight={700} sx={{ color: 'common.white' }}>
              $900
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)' }}>
              one-time
            </Typography>
          </Stack>
          <Typography variant="body2" sx={{ color: 'success.light' }}>
            Save $300 vs. buying separately
          </Typography>
          <Button
            variant="contained"
            fullWidth
            onClick={() => window.open(STRIPE_SMART_HOME_BUNDLE_URL, '_blank')}
            sx={{
              bgcolor: 'common.white',
              color: 'primary.darker',
              fontWeight: 600,
              mt: 'auto',
              '&:hover': { bgcolor: 'grey.100' },
            }}
          >
            Choose Bundle
          </Button>
        </Box>
      </Grid>
    </Grid>
  </Stack>
)
